import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { initialize, LDClient, LDFlagSet, LDContext } from 'launchdarkly-js-client-sdk';
import { environment } from '../../../environments/environment';
import { filter } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class LaunchDarklyService {
  private flag: BehaviorSubject<LDFlagSet> = new BehaviorSubject<LDFlagSet>(undefined);
  private ldClient: LDClient;

  get flagChange() {
    return this.flag.pipe(
      filter((flag) => flag !== undefined),
    );
  }

  /**
   * Identifies a context for LaunchDarkly feature flag evaluation.
   * @param context - LDContext object for flag evaluation
   */
  identify(context: LDContext) {
    if (!environment.launchDarklyClientId) { return; }

    if (!this.ldClient) {
      this.ldClient = initialize(environment.launchDarklyClientId, context);
      this.ldClient.on('ready', () => this.flag.next(this.ldClient.allFlags()));
      this.ldClient.on('change', () => this.flag.next(this.ldClient.allFlags()));
    } else {
      this.ldClient.identify(context);
    }
  }

  /**
   * Gets the boolean value of a feature flag.
   * @param key - The flag key
   * @param defaultValue - The default value if the flag is not found or client is not ready
   * @returns The boolean flag value
   */
  getBooleanFlag(key: string, defaultValue = false): boolean {
    if (!this.ldClient) {
      console.warn(`LaunchDarkly client not initialized, returning default value for flag: ${key}`);
      return defaultValue;
    }
    return this.ldClient.variation(key, defaultValue);
  }
}
